<template>
  <div id="stickyBar" class="sticky-bar-wrapper">
    <transition name="sticky-transition">
      <div
        v-show="isLandingPage || enableSticky"
        class="sticky-bar bottom theme-bg theme--light lp-rfp"
        id="stickyBarBottom"
      >
        <p class="sticky-bar--title" v-if="title">{{ title }}</p>
        <div class="sticky-bar--buttons">
          <div class="pdp-btn-wrapper">
            <div class="pdp-rfp-btn">
              <template v-if="btnEnable">
                <div class="_rfp_mctb_popup_01_ rfp-mctb-common-buynow-header">
                  <button
                    v-if="!iscommerceconnector"
                    @click="clickBuynow"
                    class="_rfp_mctb_popup_02_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
                  >
                    {{ buynowText }}
                  </button>
                  <template v-else>
                    <slot name="cta"></slot>
                  </template>
                </div>
              </template>
            </div>
          </div>
          <slot name="salon"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'sticky-bar',
  props: {
    isLandingPage: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    buynowText: {
      type: String,
      default: 'Buy now',
    },
  },
  data() {
    return {
      enableSticky: false,
      btnEnable: false,
      iscommerceconnector: false,
      footerEle:''
    };
  },
  mounted() {
    this.footerEle = document.querySelector('footer');
    if (!this.isLandingPage) {
      window.addEventListener('scroll', this.handleScroll);
    }
    let mctbOrcommercebtn = document.getElementsByClassName(
      'rfp-mctb-common-buynow'
    );
    if (mctbOrcommercebtn && mctbOrcommercebtn.length >= 1) {
      this.btnEnable = true;
    } else {
      this.btnEnable = false;
    }
    let commercecta = document.getElementsByClassName(
      'commerce-connector__button'
    );
    if (commercecta && commercecta.length >= 1) {
      this.iscommerceconnector = true;
    } else {
      this.iscommerceconnector = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const element = document.getElementById('stickyBar');
      const isInViewport = this.isInViewport(element);
      if (!isInViewport) {
        this.enableSticky = true;
        let stickyBar = document.querySelector('.sticky-bar');
        let stickyBarHeight = stickyBar ? stickyBar.offsetHeight : 0;
        if(this.footerEle) {
          this.footerEle.style.paddingBottom  = (stickyBarHeight + 32) + 'px';
        } 
      } else {
        this.enableSticky = false;
      }
    },
    clickBuynow() {
      eventBus.$emit('rfp-auto-popup-open-buynow-true');
    },
    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
  },
};
</script>
